import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { getUserDetails } from '../util/GetUser';
import { Dropdown } from 'antd';
import avatar from '../assets/login.png'

function Navbar({active}) {
  const [user, setUser] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = getUserDetails();
    setUser(userDetails);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('toDoAppUser');
    setUser("");
    navigate('/');
    setMenuOpen(false);
  }

  const closeMenu = () => setMenuOpen(false);

  const items = [
    {
      key: '1',
      label: <span onClick={handleLogout}>Logout</span>,
    },
  ];

  return (
    <header>
      <nav>
        <div className='logo__wrapper'>
          <img src={logo} alt="logo" />
          <h4>DoDo</h4>
        </div>

        {/* Desktop menu */}
        <ul className="navigation-menu desktop-menu">
          <li><Link to="/" className={active === 'home' ? 'activeNav' : ''}>Home</Link></li>
          {user && (
            <li>
              <Link to="/to-do-list" className={active === 'myTask' ? 'activeNav' : ''}>My Task</Link>
            </li>
          )}
          {user ?
            <Dropdown menu={{items}} placement="bottom" arrow trigger={['click']}>
              <div className="userInfoNav">
                <img src={avatar} alt="avatar icon" />
                <span>
                  {user?.firstName ? `Hello, ${user?.firstName} ${user?.lastName}` : user?.username}
                </span>
              </div>
            </Dropdown>
            :
            <>
              <li><Link to="/login">Login</Link></li>
              <li><Link to="/register">Register</Link></li>
            </>
          }
        </ul>

        {/* Hamburger button (mobile only) */}
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile dropdown menu */}
        {menuOpen && (
          <ul className="navigation-menu mobile-menu">
            <li><Link to="/" className={active === 'home' ? 'activeNav' : ''} onClick={closeMenu}>Home</Link></li>
            {user && (
              <li>
                <Link to="/to-do-list" className={active === 'myTask' ? 'activeNav' : ''} onClick={closeMenu}>My Task</Link>
              </li>
            )}
            {user ?
              <li><span className="mobile-logout" onClick={handleLogout}>Logout</span></li>
              :
              <>
                <li><Link to="/login" onClick={closeMenu}>Login</Link></li>
                <li><Link to="/register" onClick={closeMenu}>Register</Link></li>
              </>
            }
          </ul>
        )}
      </nav>
    </header>
  )
}

export default Navbar